<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%" >
        <v-flex lg12 pa-5>
          <v-layout v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
            <h2 class="primary--text text-uppercase textoAjustado text-center">{{ localization.edit.title }}</h2>
          </v-layout>
          <v-divider class="divider_subtitle" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1"/>
          <v-layout wrap justify-center v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
            <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-text-field v-model="nombreProv" id="nombreProv" :label="localization.edit.nombre"
                disabled />
            </v-flex>

            <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-text-field v-model="telfProv" id="telfProv" :label="localization.edit.telefono"
                :rules="[rules.integerNumber0]" />
            </v-flex>

            <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-text-field v-model="emailProv" id="emailProv" :label="localization.edit.email" maxlength="100" @input="updatingEmailCheck(emailProv)" />
            </v-flex>

            <v-flex xs12 sm12 md3 lg3 pl-3 pr-3>
              <v-text-field v-model="movilProv" id="movilProv" :label="localization.edit.movil" />
            </v-flex>

            <v-flex v-if="idubapi.rolProveedorWeb" lg12 md12 xs12 sm12 pl-3 pr-3>
              <v-row>
                <v-col cols="3">
                      <v-checkbox
                      style="margin-top: 0px !important"
                      :value="altaIncidencias"
                      color="primary"
                      :label="localization.edit.altaIncidencias"
                      :disabled = "!selectedIsActor"
                      @change="checkCambiado('altaIncidencias',$event)"
                    />     
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                      style="margin-top: 0px !important"
                      :value="gestionEstados"
                      color="primary"
                      :label="localization.edit.gestionEstados"
                      :disabled = "!selectedIsActor || selectedIsActor && accesoTodasIncidencias"
                      @change="checkCambiado('gestionEstados',$event)"
                    />
                </v-col>
                <v-col cols="3" v-if="permitirAsignarPromocionesProveedor === true">
                  <v-checkbox
                      style="margin-top: 0px !important"
                      id="accesoTodasIncidencias"
                      :value="accesoTodasIncidencias"
                      color="primary"
                      :label="localization.edit.accesoTodasIncidencias"
                      :disabled = "!selectedIsActor"
                      @change="checkCambiado('accesoTodasIncidencias',$event)"
                    />
                </v-col>
                <v-col cols="3" v-if="permitirAsignarPromocionesProveedor === true && this.accesoTodasIncidencias == true">
                  <div @click="mostrarPopupPromociones()" >
                    <v-autocomplete
                      v-model="promocionesSeleccionadasProveedor" id="promocionesSeleccionadasProveedor"
                      :no-data-text="$t('sinDatos')"
                      :items="promotionsProveedor"
                      :label="localization.edit.promocionesProveedor"
                      item-value="id"
                      :item-text="codenamePromocion"
                      readonly
                      multiple
                      >
                    </v-autocomplete>
                    </div>
                </v-col>
              </v-row>
            </v-flex>

            <v-flex mb-2>
              <v-btn color="primary" right @click="updateProveedor()"
                :disabled="itemSelected.length <= 0">
                {{localization.edit.guardar}}
              </v-btn>
              <!--<v-btn color="primary" v-if="emailIsChanging === false || emailList === false" right @click="updateProveedor()"
                :disabled="itemSelected.length <= 0">
                {{localization.edit.guardar}}
              </v-btn>
              <v-btn color="primary" v-if="emailIsChanging === true && emailList === true" right @click="openDialogEmailChanged()"
                :disabled="itemSelected.length <= 0">
                {{localization.edit.guardar}}
              </v-btn>-->
            </v-flex>
          </v-layout>

          <v-layout>
            <h2 class="primary--text text-uppercase textoAjustado text-center">{{localization.list.title}}</h2>
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-flex md8 mt-2 mb-5>
            <v-text-field v-model="search" id="search" prepend-icon="search" single-line hide-details
              @click:prepend="submitSearch(search)" @keyup.enter.native="submitSearch(search)"
            />
          </v-flex>
          <v-data-table :headers="headers" 
          :items="proveedoresByString"
            class="elevation-1" :single-select="singleSelect"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
              'items-per-page-text': $t('filasPorPagina'),
            }"
            show-select v-model="itemSelected" id="itemSelected" 
           
            :loading="tableLoading">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id + '-' + item.id_actor">
                  <td><v-checkbox v-model="itemSelected" :id="'itemSelected_' + item.id" :value="item.id" @change="updateSelection(item)" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1"></v-checkbox></td>
                  <td class="text-xs-center">{{ item.code }}</td>
                  <td class="text-xs-center" v-if="NAV">{{ item.denominacion }}</td>
                  <td class="text-xs-center">{{ item.name }}</td>
                  <td class="text-xs-center">{{ item.phone }}</td>
                  <td class="text-xs-center">{{ item.movil }}</td>
                  <td class="text-xs-center">{{ item.email }}</td>
                  <td class="text-xs-center" v-if="!item.emailList">{{ item.accesoApp === '0' ? no : si + ' ('+ item.accesoApp + ')' }}</td>
                  <v-tooltip max-width="320px" bottom v-if="item.emailList">
                    <template v-slot:activator="{ on }">
                      <td class="text-xs-center" v-on="on">{{ item.accesoApp === '0' ? no : si + ' ('+ item.accesoApp + ')' }}</td>
                    </template>
                    <span>{{ item.emailList }}</span>
                  </v-tooltip>
                  <td class="text-xs-center">
                    <v-flex row justify-center v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
                        <v-icon class="iconSize" small @click="showPopupActoresProveedores(item)">mdi-account-group</v-icon>
                    </v-flex>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
      <ConfirmAccesoApp v-if="emailIsEmpty === false"
        :text="textoCrearActorDeProveedorConActor"
        :title="tituloProveedorConActor"
        :dialogFlag="dialogEmail"
        :showCancel=true
        @aceptar="aceptarCambioEmailProveedor = true; updateProveedor()"
        @cancel="dialogEmail = false"
      />
      <ConfirmAccesoApp v-else
        :text="textoEmailProveedorVacio"
        :title="textoTitleEmailEmpty"
        :dialogFlag="dialogEmail"
        :showCancel=false
        @aceptar="dialogEmail = false"
      />
      <ConfirmDialog 
        :text="textoUnselectAccesoTodasIncidencias"
        @close="dialogAccesoTodasIncidencias = false" 
        @cancel="dialogAccesoTodasIncidencias = false; accesoTodasIncidencias = true"
        :dialogFlag="dialogAccesoTodasIncidencias" 
        :textoBoton="textoAceptar" 
        textoTitulo="" />
      <ConfirmDialog @close="confirmarCrearProveedor()" :text="textoConfirmacion"
          @cancel="dialogConfirmacion = false" :dialogFlag="dialogConfirmacion" :textoBoton="textoAceptar" :textoTitulo="tituloCrearActor" />
      
      <custom-dialog
        v-if="this.mostrarPopupActoresProveedor === true"
        v-model="mostrarPopupActoresProveedor" 
        id="mostrarPopupActoresProveedor"
      >
        <PopUpActoresProveedor
          :multiple="false"
          :proveedorId="idProv"
          :provider="itemProvider"
          @selected="provSelected = $event"
        />
      </custom-dialog>

    </v-layout>
    <v-fade-transition>
      <custom-dialog
        v-if="mostrarSeleccionarPromociones"
        v-model="mostrarSeleccionarPromociones" id="mostrarSeleccionarPromociones"
      >
        <PopUpSeleccionarPromocionesProvider
          :multiple="true"
          :idProveedor="idProv"
          @selected="promocionesSeleccionadasProveedor = $event"
        />
      </custom-dialog>
    </v-fade-transition>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rulesMixin from '../../generic/rules'
import ConfirmAccesoApp from '../../custom/confirmAccesoApp'
import ConfirmDialog from '../../custom/confirmDialog'
import PopUpSeleccionarPromocionesProvider from './PopUpSeleccionarPromocionesProvider'
import PopUpActoresProveedor from './PopUpActoresProveedor'

export default {
  components: {
    ConfirmAccesoApp,
    ConfirmDialog,
    PopUpSeleccionarPromocionesProvider,
    PopUpActoresProveedor
  },
  mixins: [rulesMixin],
  data () {
    return {
      tableLoading: false,
      singleSelect: true,
      itemSelected: [],
      search: null,
      idProv: null,
      nombreProv: null,
      telfProv: null,
      emailProv: [],
      movilProv: null,
      emailIsChanging: false,
      dialogEmail: false,
      // textoConfirmacion: '¿Está seguro de que desea modificar el email del proveedor?',
      tituloProveedorConActor: 'Proveedor con acceso a App',
      textoConfirmacion: this.$t('verIncidencia').dialogConfirmacion.textoConfirmarActorProveedor,
      textoCrearActorDeProveedorConActor: this.$t('verIncidencia').dialogConfirmacion.textoCrearActorDeProveedorConActor,
      tituloCrearActor: this.$t('verIncidencia').dialogConfirmacion.titulo,
      textoAceptar: this.$t('verIncidencia').dialogConfirmacion.boton,
      textoEmailProveedorVacio: this.$t('verIncidencia').dialogConfirmacion.textoEmailProveedorVacio,
      textoTitleEmailEmpty: this.$t('verIncidencia').dialogConfirmacion.textoTitleEmailEmpty,
      textoUnselectAccesoTodasIncidencias: this.$t('verIncidencia').dialogConfirmacion.textoUnselectAccesoTodasIncidencias,
      dialogConfirmacion: false,
      dialogAccesoTodasIncidencias: false,
      emailList: false,
      aceptarCambioEmailProveedor: false,
      emailIsEmpty: false,
      NAV: false,
      si: this.$t('si'),
      no: this.$t('no'),
      altaIncidencias: false,
      gestionEstados: false,
      accesoTodasIncidencias: false,
      selectedIsActor: false,
      promotionsProvider: [],
      promocionesSeleccionadasProveedor: [],
      mostrarSeleccionarPromociones: false,
      mostrarPopupActoresProveedor: false,
      itemProvider: []
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi',
      promotionsProveedor: 'gestion/getPromotionsProvider',
      getConfiguracion: 'configuracion/getConfiguracion'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    headers () {
      const labelAcceso = (this.idubapi.rolProveedorWeb) ? this.localization.list.accesoAppWeb : this.localization.list.acceso;

      if(this.NAV) {
        return [
          { text: this.localization.list.codigo, value: 'code', sortable: true, align: 'left' },
          { text: this.localization.list.sociedad, value: 'denominacion', sortable: true, align: 'left' },
          { text: this.localization.list.nombre, value: 'name', sortable: true, align: 'left' },
          { text: this.localization.list.telefono, value: 'phone', sortable: true, align: 'left' },
          { text: this.localization.list.movil, value: 'movil', sortable: true, align: 'left' },
          { text: this.localization.list.email, value: 'email', align: 'left' },
          { text: labelAcceso, value: 'accesoApp', align: 'left' },
          { text: this.localization.list.opciones, value: 'opciones', align: 'left' }
        ]
      } else {
        return [
          { text: this.localization.list.codigo, value: 'code', sortable: true, align: 'left' },
          { text: this.localization.list.nombre, value: 'name', sortable: true, align: 'left' },
          { text: this.localization.list.telefono, value: 'phone', sortable: true, align: 'left' },
          { text: this.localization.list.movil, value: 'movil', sortable: true, align: 'left' },
          { text: this.localization.list.email, value: 'email', align: 'left' },
          { text: labelAcceso, value: 'accesoApp', align: 'left' },
          { text: this.localization.list.opciones, value: 'opciones', align: 'left' }
        ]
      }
    },
    localization () {
      return this.$t('maestros.proveedores')
    },
    permitirAsignarPromocionesProveedor () {
      return this.getConfiguracion.permitirAsignarPromocionesProveedor
    },
    proveedoresByString () {
      if (this.$store.state.incidencias.providersByString) {
        // return this.$store.state.incidencias.providersByString
        return this.sortItemsByField(this.$store.state.incidencias.providersByString,'name')
      }
      return []
    }
  },
  mounted () {
    this.NAV = (this.idubapi.motor === 'SQLSERVER')
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getProvidersByString: 'incidencias/getProvidersByString',
      updateProviders: 'incidencias/updateProviders',
      crearActorAsociadoRolProveedor: 'incidencias/crearActorAsociadoRolProveedor',
      getPromotionsProvider: 'gestion/getPromotionsProvider',
      checkProviderHasPromotions: 'gestion/checkProviderHasPromotions',
      getActorsProvider: 'gestion/getActorsProvider'
    }),
    async showPopupActoresProveedores(item) {

      if(this.idubapi.rolProveedor && item.id_actor == null) {
        this.idProv = item.id
        if(item.email === '') {
          this.addAlert({texto: this.localization.mailerror, color: 'error'})
          return
        }
        this.dialogConfirmacion = true
        return 
      }
      
      this.itemProvider = item

      this.mostrarPopupActoresProveedor = true
      await this.getActorsProvider(item.id)
      console.log(this.$store.state.gestion.actorsProvider)
    },
    async updateSelection (item) {
      if(item.id_actor === null || this.itemSelected.length === 0){
        this.selectedIsActor = false
      }else{
        this.selectedIsActor = true
      }

      this.emailIsChanging = false
      this.nombreProv = item.name
      this.idProv = item.id
      item.phone !== ' ' ? this.telfProv = item.phone : this.telfProv = ''
      this.emailProv = item.email
      this.movilProv = item.movil
      item.altaIncidencias == '1' ? this.altaIncidencias = true : this.altaIncidencias = false
      item.gestionEstados == '1' ? this.gestionEstados = true : this.gestionEstados = false
      item.accesoTodasIncidencias == '1' ? this.accesoTodasIncidencias = true : this.accesoTodasIncidencias = false
      if (this.itemSelected.length > 1) {
        this.itemSelected.shift()
        this.itemSelected.push(item)
      }
      if (this.itemSelected.length === 0) {
        this.nombreProv = null
        this.idProv = null
        this.telfProv = null
        this.emailProv = null
        this.movilProv = null
        this.altaIncidencias = false
        this.gestionEstados = false
        this.accesoTodasIncidencias = false
      }
      if (item.emailList) {
        this.emailList = true
      } else {
        this.emailList = false
      }
      if (item.accesoTodasIncidencias == true) {
        this.promocionesSeleccionadasProveedor = []

          this.loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel
          })

          await this.getPromotionsProvider(this.idProv).then(() => {
            this.$store.state.gestion.promotionsProvider.map(promocion => {
              if ( promocion.selected == '1' ) {
                this.promocionesSeleccionadasProveedor.push(promocion)
              }
            })
            
            this.loader.hide()
          })
          .catch(e => {
            this.loader.hide()
            return e
          })
      }
    },
    mostrarPopupPromociones () {
      if ( this.mostrarSeleccionarPromociones === false ) {
        this.mostrarSeleccionarPromociones = true
      }
      else {
        this.mostrarSeleccionarPromociones = false
      }
    },
    codenamePromocion (item) {
      return item.code + ' - ' + item.name
    },
    updatingEmailCheck (email) {
      if(email === "") {
        this.emailIsEmpty = true
      }
      else {
        this.emailIsEmpty = false
      }
      this.emailIsChanging = true
    },
    async submitSearch (searchString) {
      try {
        this.nombreProv = null
        this.telfProv = null
        this.emailProv = null
        this.movilProv = null
        this.tableLoading = true
        this.altaIncidencias = false
        this.gestionEstados = false
        this.accesoTodasIncidencias = false
        await this.getProvidersByString(searchString)
        this.tableLoading = false
        this.itemSelected = []
      } catch (error) {
        this.tableLoading = false
        this.addAlert({texto: error, color: 'error'})
      }
    },
    openDialogEmailChanged () {
      this.dialogEmail = true
    },
    async updateProveedor () {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        this.dialogEmail = false
        const arrayEmail = []
        let emails = []
        let validEmails = true
        const expresionRegular = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/
        arrayEmail.push(this.emailProv)

        if(this.emailProv.search(';') !== -1) {
          emails = this.emailProv.split(';')
          emails.map(function(email){
            if (expresionRegular.test(email.trim()) !== true) {
              validEmails = false
            }
          })
        }
        else {
          if (expresionRegular.test(this.emailProv.trim()) !== true) {
            validEmails = false
          }
        }

        if(this.emailProv.trim() === '') {
          validEmails = true
        }
        if (validEmails === true) {
          
          if ( this.permitirAsignarPromocionesProveedor === true && this.accesoTodasIncidencias === true && this.promocionesSeleccionadasProveedor.length === 0 ) {
            this.loader.hide()
            this.addAlert({texto: this.$t('debeSeleccionarPromocionesProveedor'), color: 'error'})
            return
          }

          const newItem = {
            email: this.emailProv,
            id: this.idProv,
            movil: this.movilProv,
            phone: this.telfProv,
            altaIncidencias: (this.altaIncidencias === true) ? 1 : 0,
            gestionEstados: (this.gestionEstados === true) ? 1 : 0,
            accesoTodasIncidencias: (this.accesoTodasIncidencias === true) ? 1 : 0,
            promociones: this.promocionesSeleccionadasProveedor
          }
          await this.updateProviders(newItem)
          this.search = ''
          this.$store.commit('incidencias/setProvidersByString', [])
          this.loader.hide()
          // esta parte vamos a ponerla en el boton nuevo de gestion de actores proveedores
          
          // if(this.idubapi.rolProveedor && this.itemSelected[0].id_actor == null) {
          //   this.dialogConfirmacion = true
          // } else {
          //   // console.log(this.aceptarCambioEmailProveedor)
          //   if(this.aceptarCambioEmailProveedor === true) {
          //     this.confirmarCrearProveedor()
          //   }
          //   this.itemSelected = []
          // }
          this.addAlert({texto: this.$t('proveedorActualizado'), color: 'success'})
          this.nombreProv = null
          this.telfProv = null
          this.emailProv = null
          this.movilProv = null
          this.tableLoading = true
          this.altaIncidencias = false
          this.gestionEstados = false
          this.accesoTodasIncidencias = false
          this.itemSelected = []
          this.selectedIsActor = false
        }
        else {
          this.loader.hide()
          this.addAlert({texto: "email/s no válido/s.", color: 'error'})
        }
      } catch (error) {
        this.loader.hide()
        this.addAlert({texto: error, color: 'error'})
      }
    },
    async confirmarCrearProveedor() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        await this.crearActorAsociadoRolProveedor(this.idProv)
        this.loader.hide()
        this.dialogConfirmacion = false
        this.itemSelected = []
        this.nombreProv = null
        this.telfProv = null
        this.emailProv = null
        this.movilProv = null
        this.addAlert({texto: this.$t('accesoAppConcedido'), color: 'success'})
      } catch (error) {
        this.itemSelected = []
        this.dialogConfirmacion = false
        this.loader.hide()
        this.addAlert({texto: error.message, color: 'error'})
      }
    },
    async checkCambiado(element,value){
      console.log(this.promotionsProveedor)
      switch(element){
        case 'altaIncidencias':
            value === true ? this.altaIncidencias = true : this.altaIncidencias = false
          break;
        case 'gestionEstados':
            value === true  ? this.gestionEstados = true : this.gestionEstados = false
          break;
        case 'accesoTodasIncidencias':
            value === true  ? this.accesoTodasIncidencias = true : this.accesoTodasIncidencias = false
            if (this.accesoTodasIncidencias === true) {
              this.dialogAccesoTodasIncidencias = false
              this.gestionEstados = false
              this.promocionesSeleccionadasProveedor = []
              this.loader = this.$loading.show({
                // Optional parameters
                container: this.fullPage ? null : this.$refs.formContainer,
                canCancel: false,
                onCancel: this.onCancel
              })
              
              await this.getPromotionsProvider(this.idProv).then(() => {
                this.$store.state.gestion.promotionsProvider.map(promocion => {
                  if ( promocion.selected == '1' ) {
                    this.promocionesSeleccionadasProveedor.push(promocion)
                  }
                })
            
              this.loader.hide()
              })
              .catch(e => {
                this.loader.hide()
                return e
              })
            }
            else {
              let promocionesSeleccionadasProveedor = []
              let promocionesSeleccionadasProveedorOtroActor = []
              promocionesSeleccionadasProveedor = this.promotionsProveedor.filter(promocion => promocion.selected == '1' && promocion.actorId == this.usuario.id)
              promocionesSeleccionadasProveedorOtroActor = this.promotionsProveedor.filter(promocion => promocion.selected == '1' && promocion.actorId != null && promocion.actorId != this.usuario.id)

              if ( promocionesSeleccionadasProveedor.length == 0  && promocionesSeleccionadasProveedorOtroActor.length > 0 ) {
                this.dialogAccesoTodasIncidencias = true
              }
              else {
                this.dialogAccesoTodasIncidencias = false
              }

              // if ( promocionesSeleccionadasProveedor.length === 0 ) {
              //   this.loader = this.$loading.show({
              //   // Optional parameters
              //   container: this.fullPage ? null : this.$refs.formContainer,
              //   canCancel: false,
              //   onCancel: this.onCancel
              // })

              // await this.checkProviderHasPromotions(this.idProv).then(() => {
              //   if (this.$store.state.gestion.checkProviderHasPromotions === true ) {
              //     this.dialogAccesoTodasIncidencias = true
              //   }
              //   this.loader.hide()
              // })
              // .catch(e => {
              //   this.loader.hide()
              //   return e
              // })
              // }
            }
          break;
      }
    },
    sortItemsByField(items, field){
     let lista = [...items]

      return lista.sort(function (a, b) {
        if(a === null || typeof a[field] === "undefined" || a[field] === null){
          return 1
        }
        if(b === null || typeof b[field] === "undefined" || b[field] === null){
          return -1
        }
        let x = a[field].trim().toLowerCase()
        let y = b[field].trim().toLowerCase()
        if (x > y) {
          return 1
        }
        if (x < y) {
          return -1
        }
        return 0
      });
    }
  }
}
</script>
